/** Picks the routing backend: mock (default, fed by the mock chat data) or `/api/v1` (same origin/session as ../index.ts). */
import { getApi, useMock } from '../index'
import { MockChatApi } from '../mock'
import { HttpRoutingApi } from './http'
import { MockRoutingApi, mockRoutingRole } from './mock'
import type { RoutingApi } from './types'

let current: RoutingApi | null = null

export function getRoutingApi(): RoutingApi {
  if (!current) {
    const base = (import.meta.env.VITE_API_BASE ?? '').trim()
    current = useMock
      ? new MockRoutingApi({
          role: mockRoutingRole(),
          db: () => {
            const chat = getApi()
            return chat instanceof MockChatApi ? chat.db : null
          },
        })
      : new HttpRoutingApi(base)
  }
  return current
}

/** Tests inject their own backend. */
export function setRoutingApi(api: RoutingApi | null): void {
  current = api
}

export type * from './types'
